import Service, { service } from '@ember/service';
import type Store from '@ember-data/store';
import type DigitalAsset from 'tio-data/models/digital-asset';

export interface DigitalAssetDetailSignature {
  bucket: string;
  uuid: string;
  filename: string;
  name: string;
  key: string;
  classification?: string;
}

export default class DigitalAssetsService extends Service {
  @service declare store: Store;

  /**
   *
   * @param {string} modelName - the model name for the asset type, ex. 'publicAsset'
   * @param {object} details - the uploaded file details returned from S3
   * @returns {Model} - returns a model of the asset type provided in CREATED state (i.e. NOT saved)
   */
  createAssetFromS3Details = (modelName: string, details: DigitalAssetDetailSignature) => {
    const assetType = modelName || 'digitalAsset';
    return this.store.createRecord(assetType, {
      bucket: details.bucket,
      uuid: details.uuid,
      filename: details.filename,
      name: details.name,
      fullPath: details.key,
      classification: details.classification,
    }) as DigitalAsset;
  };
}
